import { render, staticRenderFns } from "./LostPasswordConfirm.vue?vue&type=template&id=2ba18821&"
import script from "./LostPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./LostPasswordConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports